import React from "react";
import styled from "styled-components";
import { Layout, Row, Col } from "antd";
import PropTypes from "prop-types";

import useStyleContext from "../providers/Style";
import Header from "./Header";

const StyledLayout = styled(Layout)`
  background-color: rgba(0, 0, 0, 0.6);
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    background-color: ${({ theme }) => theme.palette.white};
  }
`;

const handleSideMenuMargin = ({
  theme,
  $isDesktop,
  $sidemenuOpen,
  $noSidemenu,
  $scrollbarWidth,
}) => {
  let sidemenuMargin = 0;
  if ($isDesktop && !$noSidemenu) {
    sidemenuMargin = 16 + ($sidemenuOpen ? theme.sidemenuWidth.desktop : 24);
  }
  const translateX = $noSidemenu
    ? false
    : Math.round(sidemenuMargin / 2) - ($isDesktop ? 8 : 0);
  return `
    width: calc(100vw - ${
      sidemenuMargin + ($scrollbarWidth || 0) + ($isDesktop ? 28 : 36)
    }px);
    ${translateX ? `transform: translateX(${translateX}px);` : ""}
  `;
};

const StyledContent = styled(Layout.Content)`
  ${({ theme, $noMaxWidth }) =>
    $noMaxWidth ? "" : `max-width: ${theme.contentMaxWidth}px;`}
  ${handleSideMenuMargin}
  background-color: ${({ theme }) => theme.palette.white};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    background-color: ${({ theme }) => theme.palette.white};
  }

  margin: 24px 20px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    margin: 5% auto;
    border-radius: 8px;
    max-width: 534px;
  }

  transition: all 0.1s linear;
  & > .ant-row {
    width: 100%;
    @media screen and (min-width: ${({ theme }) =>
        theme.breakpoints.tablet}px) {
      padding: 24px 48px;
    }
  }
  flex: none;
`;

const Content = ({
  children,
  className,
  noSidemenu,
  noMaxWidth,
  hideHeaderLogo,
}) => {
  const { isDesktop, sidemenuOpen, scrollbarWidth } = useStyleContext();
  const numColumns = React.Children.toArray(children).filter(
    ({ type }) => type.name === "Column"
  ).length;
  return (
    <StyledContent
      className={className}
      $numColumns={numColumns}
      $isDesktop={isDesktop}
      $sidemenuOpen={sidemenuOpen}
      $noSidemenu={noSidemenu}
      $scrollbarWidth={scrollbarWidth}
      $noMaxWidth={noMaxWidth}
    >
      <Row justify="center" gutter={numColumns ? 24 : 0}>
        {!hideHeaderLogo && <Header onlyLogo />}
        {children}
      </Row>
    </StyledContent>
  );
};

Content.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  noSidemenu: PropTypes.bool,
  noMaxWidth: PropTypes.bool,
  hideHeaderLogo: PropTypes.bool,
};

Content.defaultProps = {
  children: null,
  className: "",
  noSidemenu: false,
  noMaxWidth: false,
  hideHeaderLogo: false,
};

const Container = ({ children, ...props }) => {
  return <StyledLayout {...props}>{children}</StyledLayout>;
};

Container.propTypes = {
  children: PropTypes.node,
};

Container.defaultProps = {
  children: null,
};

const StyledCol = styled(Col)`
  padding-left: 12px;
  padding-right: 12px;
`;

const Column = ({ children, desktop, className, ...props }) => {
  const mdProp = desktop ? { md: parseInt(desktop, 10) * 3 } : {};
  const classNames = className + (desktop !== null ? " notSingle" : "");
  return (
    <StyledCol className={classNames} span={24} {...mdProp} {...props}>
      {children}
    </StyledCol>
  );
};

Column.propTypes = {
  children: PropTypes.node,
  desktop: PropTypes.string,
  className: PropTypes.string,
};

Column.defaultProps = {
  children: null,
  desktop: null,
  className: "",
};

export default { Container, Content, Column };
